import type { FC } from "react";

import { SWReactCountryIcons, Location } from "@similarweb/icons";
import { Flex } from "@similarweb/ui-components/foundations";

import translateNested from "app/pages/sales-intelligence/common-components/i18n/translateNested";
import { StyledSignalNameText } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/Signal/styles";
import type SignalNameWithCountry from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalNameWithCountry";
import type { SignalSelectionTooltipLabels } from "app/pages/sales-intelligence/sub-modules/signals/models/miscellaneous/SignalSelectionTooltipLabels";
import SignalNameHtmlWithSelectionTooltips from "app/pages/sales-intelligence/sub-modules/signals/utils/signalNameHtmlWithSelectionTooltips";
import I18n from "pro-features/components/WithTranslation/src/I18n";

type Props = {
    signalName: SignalNameWithCountry;
    selectionTooltipLabels?: SignalSelectionTooltipLabels;
};

const SignalTitleWithCountry: FC<Props> = ({ signalName, selectionTooltipLabels }) => {
    const countryCode = signalName.replacements.countryCode;

    const countryIcon = countryCode ? (
        <SWReactCountryIcons
            countryCode={countryCode}
            size="xs"
        />
    ) : (
        <Location size="xs" />
    );

    const nameContent = selectionTooltipLabels ? (
        <SignalNameHtmlWithSelectionTooltips
            translatable={signalName}
            selectionTooltipLabels={selectionTooltipLabels}
        />
    ) : (
        <I18n
            data-automation="name-text"
            dataObj={signalName.replacements}
            dangerouslySetInnerHTML
        >
            {translateNested(signalName)}
        </I18n>
    );

    return (
        <StyledSignalNameText>
            <Flex
                gap="4px"
                alignItems="flex-start"
            >
                <Flex>{countryIcon}</Flex>
                <StyledSignalNameText data-automation={selectionTooltipLabels ? "name-text" : undefined}>
                    {nameContent}
                </StyledSignalNameText>
            </Flex>
        </StyledSignalNameText>
    );
};

export default SignalTitleWithCountry;
